import {cancel, invoke, on} from "@hybird/core/bridge/hybirdBridge";
import {BridgeMethod} from "@hybird/core/bridge/core";

export class FlutterBluetoothPeripheral extends BridgeMethod {
  constructor() {
    super();
  }

  /**
   * 监听连接的用户
   *
   * @param callback{function({centralUUid: string,state:String})} 蓝牙适配器监听连接的用户
   * centralUUid:用户的deviceId，state：connected|disconnected
   * @return {Promise<{cancel:function}>} eventId
   */
  onBluetoothPeripheralConnectionStateChange(callback) {
    return on("onBluetoothPeripheralConnectionStateChange", callback, {
      isSend: true
    });
  }

  /**
   * 取消监听连接的用户
   *
   * @param callback{function({centralUUid: string,state:String})} 蓝牙适配器监听连接的用户
   * centralUUid:用户的deviceId，state：connected|disconnected
   */
  offBluetoothPeripheralConnectionStateChange(callback) {
    return cancel("onBluetoothPeripheralConnectionStateChange", {
      event: callback, isSend: true
    });
  }

  /**
   * 蓝牙设备监听特征值变化
   *
   * @param callback{function({centralUUid,serviceId,characteristicId,value})} 取消监听的回调
   * @return {Promise<{cancel:function}>} eventId
   */
  async onBluetoothPeripheralCharacteristicValueChange(callback) {
    return on("onBluetoothPeripheralCharacteristicValueChange", callback, {isSend: true});
  }

  /**
   * 蓝牙设备取消监听特征值变化
   *
   * @param callback{function?} 取消监听的回调
   */
  async offBluetoothPeripheralCharacteristicValueChange(callback) {
    return cancel("onBluetoothPeripheralCharacteristicValueChange", {event: callback, isSend: true});
  }

  /**
   * 通知方法发送数据
   *
   * @param centralUUid 用户的deviceId
   * @param value 发送的数据, hex编码格式
   */
  async bluetoothPeripheralNotifyCharacteristic(centralUUid, value) {
    return invoke("bluetoothPeripheralNotifyCharacteristic", {
      params: {
        centralUUid, value
      }
    });
  }

  /**
   * read方法数据发送，
   *
   * @param centralUUid 用户的deviceId
   * @param characteristicUUid 特征值uuid
   * @param value 发送的数据, hex编码格式
   */
  bluetoothPeripheralReadRequestWithValue(centralUUid, characteristicUUid, value) {
    return invoke("bluetoothPeripheralReadRequestWithValue", {
      params: {
        centralUUid, characteristicUUid, value
      }
    });
  }

  /**
   * 开启蓝牙广播
   * @return {Promise<void>}
   */
  startBluetoothPeripheralAdvertising() {
    return invoke("startBluetoothPeripheralAdvertising", {});
  }

  /**
   * 停止蓝牙广播
   * @return {Promise<void>}
   */
  stopBluetoothPeripheralAdvertising() {
    return invoke("stopBluetoothPeripheralAdvertising", {});
  }
}

export const flutterBluetoothPeripheral = new FlutterBluetoothPeripheral();